<template>
  <footer class="footer-area footer-style-01 bg_color--6">
    <!-- <div class="im-call-to-action-area ptb--70 im-separator">
      <v-container>
        <v-row class="align-center">
          <v-col xl="6" lg="8" md="6" sm="12" cols="12">
            <div class="inner">
              <h2 class="white--text mb--0 footer-cta-title">
                Vamos construir algo grande juntos
              </h2>
            </div>
          </v-col>
          <v-col lg="4" offset-xl="2" md="6" sm="12" cols="12">
            <div
              class="text-left call-to-cation-tbn text-md-right mt_md--20 mt_sm--20"
            >
              <a :href="whatsLink" class="cta-whatsapp footer-cta-whatsapp" target="_blank" rel="noopener">
                <i class="mdi mdi-whatsapp"></i>
                <span class="cta-text">Falar com Especialista</span>
              </a>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div> -->
    <div class="footer-wrapper ptb--70">
      <v-container class="container">
        <v-row>
          <v-col lg="4" md="4" sm="6" cols="12">
            <div class="ft-text">
              <div class="logo">
                <a href="/"><img :src="logo" alt="brand image"/></a>
              </div>
              <p>
                Copyright © {{ new Date().getFullYear() }}
                <a href="/">Codetime</a>. Todos os direitos reservados.
              </p>
              <p style="margin-top: 8px; font-size: 0.9em; opacity: 0.8;">
                CNPJ: 48.102.516/0001-73
              </p>
            </div>
          </v-col>
          <v-col
            lg="2"
            offset-xl="1"
            md="6"
            sm="6"
            cols="12"
            class="mt_mobile--40"
          >
            <div class="footer-link">
              <h4>Navegação</h4>
              <ul class="ft-link">
                <li><router-link to="/">Início</router-link></li>
                <li><router-link to="/#about">Sobre</router-link></li>
                <li><router-link to="/#contact">Contato</router-link></li>
              </ul>
            </div>
          </v-col>
          <v-col lg="2" md="2" sm="6" cols="12" class="mt_md--40 mt_sm--40">
            <div class="footer-link">
              <h4>Serviços</h4>
              <ul class="ft-link">
                <li><router-link to="/#service">Serviços</router-link></li>
                <li><router-link to="/#portfolio">Projetos</router-link></li>
              </ul>
            </div>
          </v-col>
          <v-col lg="3" md="3" sm="6" cols="12" class="mt_md--40 mt_sm--40">
            <div class="footer-link">
              <h4>Atendemos também</h4>
              <ul class="ft-link">
                <li><router-link to="/servicos/desenvolvimento-apps-balneario-camboriu">Apps em Balneário Camboriú</router-link></li>
                <li><router-link to="/servicos/sistemas-web-balneario-camboriu">Sistemas em BC</router-link></li>
                <li><router-link to="/servicos/desenvolvimento-apps-navegantes">Apps em Navegantes</router-link></li>
                <li><router-link to="/servicos/sistemas-web-navegantes">Sistemas em Navegantes</router-link></li>
              </ul>
            </div>
          </v-col>
          <v-col lg="2" md="2" sm="6" cols="12" class="mt_md--40 mt_sm--40">
            <div class="footer-link">
              <h4>Fale conosco</h4>
              <ul class="ft-link">
                <li>
                  E-mail:
                  <a href="mailto:contato@codetime.com.br">contato@codetime.com.br</a>
                </li>
                <li>Telefone: <a href="tel:+5547933807051">(47) 93380-7051</a></li>
              </ul>
              <div class="social-share-inner mt--20">
                <ul
                  class="social-share social-style--2 d-flex justify-content-start liststyle mt--15"
                >
                  <li v-for="(social, i) in socialList" :key="i">
                    <a :href="social.url" target="_blank">
                      <i class="fab" :class="social.icon"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </footer>
</template>

<script>
  export default {
    data() {
      return {
        logo: "/logoCodetimeWhite.webp",
        whatsLink: "https://wa.me/5547933807051",
        socialList: [
          // {
          //   icon: "fa-facebook-f",
          //   url: "https://www.facebook.com/",
          // },
          {
            icon: "fa-linkedin-in",
            url: "https://www.linkedin.com/company/codetime-sistemas/",
          },
          {
            icon: "fa-instagram",
            url: "https://www.instagram.com/codetime_sistemas/",
          },
        ],
      };
    },
  };
</script>
